export interface DatasourceDetails {
  /**
   * Dispaly name of the feature
   */
  displayName: string;
  /**
   * Physical value of the feature
   */
  physicalValue: string;
  /**
   * Logical value of the feature
   */
  logicalValue: string;
}

/**
 * Method for handling the gender or ethnic band checkbox fields
 * @param featureType Type of feature
 * @returns Details
 */
export const GenderOrEthnicBand = (featureType: string): DatasourceDetails[] => {
  return JSON.parse(
    sessionStorage?.getItem("query-builder-datamap") as string
  ).rules.demographics.features[featureType].dataValues;
};
